import { defineStore } from 'pinia';

export type ShopCartState = {
  isShopCartOpen: boolean;
  isShopCartFlashing: boolean;
};

export const useShopCartStore = defineStore('shop-cart', {
  state: (): ShopCartState => {
    return {
      isShopCartOpen: false,
      isShopCartFlashing: false,
    };
  },
  actions: {
    setShopCartOpen(newState: ShopCartState['isShopCartOpen']) {
      return (this.isShopCartOpen = newState);
    },
    setShopCartFlashing(newState: ShopCartState['isShopCartFlashing']) {
      return (this.isShopCartFlashing = newState);
    },
  },
});
